import { METHOD_POST } from 'requests';

import { CUSTOMER_TEAMS } from 'constants/endpoints';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_POST_editRankingCSV = ({
  formData,
}: {
  formData: FormData;
}): ApiRequestConfigType => {
  const url = `${CUSTOMER_TEAMS}/csv/import`;
  return {
    __typename: 'LegacyAPI',
    method: METHOD_POST,
    url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: formData,
  };
};
